import React from 'react'
import PropTypes from 'prop-types'

const BASE_CLASSES = 'tw:rounded! tw:px-1.5 tw:py-0.5 tw:text-xs tw:font-medium'
const NOWRAP_CLASS = 'tw:inline-block tw:whitespace-nowrap'
const WRAP_CLASS = 'tw:inline tw:box-decoration-clone tw:wrap-anywhere'

const VARIANTS = {
  success: 'tw:bg-ds-primary-lowest-enabled tw:text-ds-primary-highest',
  progress: 'tw:bg-ds-progress-lowest tw:text-ds-progress-pressed',
  danger: 'tw:bg-ds-danger-lowest tw:text-ds-danger',
  neutral: 'tw:bg-gray-100 tw:text-gray-700',
  warning: 'tw:bg-orange-100 tw:text-orange-700'
}

const Badge = ({ children, variant, wrap }) => {
  const wrapClass = wrap ? WRAP_CLASS : NOWRAP_CLASS
  return <span className={`${BASE_CLASSES} ${wrapClass} ${VARIANTS[variant]}`}>{children}</span>
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['success', 'progress', 'danger', 'neutral', 'warning']),
  wrap: PropTypes.bool
}

Badge.defaultProps = {
  variant: 'success',
  wrap: false
}

export default Badge
